import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import {TranslateService} from '@ngx-translate/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { AuthenticationService } from 'app/core/authentication/authentication.service';
import { Logger } from 'app/core/logger.service';
import * as Models from 'app/core/models';

const log = new Logger('App');
@Component({
    selector: 'app-reset-password-modal',
    templateUrl: './resetPasswordModal.component.html',
    styleUrls: ['./resetPasswordModal.component.scss']
})

export class ResetPasswordModalComponent implements Models.ModalComponent {

    @ViewChild('modalResetPassword') public contentModal: any;

    version: string = environment.version;
    error: any = null;
    resetPassowrdForm: FormGroup;
    isLoading = false;
    showForm = true;
    showSuccessMessage = false;
    token: string;
    userId: string;

    constructor(private formBuilder: FormBuilder,
                private router: Router,
                private authenticationService: AuthenticationService,
                private translateService: TranslateService) {
        this.createForm();
    }

    reset() {
        this.resetPassowrdForm.reset();
        this.showSuccessMessage = false;
        this.showForm = true;
    }

    resetPassword() {
        this.isLoading = true;
        const data: Models.ResetPassword = {
            newPassword: this.resetPassowrdForm.get('password').value,
            token: this.token,
            userId: this.userId
        };
        this.authenticationService.resetPassword(data)
            .finally(() => {
                if (!this.error) {
                    this.resetPassowrdForm.markAsPristine();
                    this.resetPassowrdForm.reset();

                    this.router.navigate(['/home']);
                }
                this.isLoading = false;
            })
            .subscribe(credentials => {
                log.debug(`successfully reset password`);
                this.error = undefined;
                this.showForm = false;
                this.showSuccessMessage = true;
            }, error => {
                log.debug(`reset password error: ${error}`);
                this.error = error;
            });
    }

    get errorMessage(): string {
        if (this.error) {
            const errorBody = this.error._body ? JSON.parse(this.error._body) : null;
            if (errorBody && errorBody.error) {
              return errorBody.error;
            }
        }
      this.translateService.get('AUTH.RESET_PASSWORD.GENERAL_ERROR').subscribe((translatedErrMsg: string) => {
        return translatedErrMsg
      });
    }

    openModal(args: any[]) {
        this.userId = args[0];
        this.token = args[1];
        this.reset();
        this.contentModal.show();
    }

    closeModal() {
        this.contentModal.hide();
    }

    private createForm() {
        this.resetPassowrdForm = this.formBuilder.group({
            password: ['', Validators.minLength(6)],
            confirmPassword: ['', Validators.minLength(6)]
        });
    }
}




// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/resetPassword/resetPasswordModal.component.ts